// eslint-disable-next-line import/named
import React, { useState } from 'react';
import { Information } from '../information/information';
import { Profil } from '../profil/profil';
import { Charter } from '../charter/charter';
import '../pages.css';
import { ArticlesRender } from '../article/article';
import { useDataApiIsSigned } from '../../Hooks/useDataUsersApi';
import { AddArticle } from '../article/addArticle';
import { EditArticle } from '../article/editArticle';
import { Redirect, Switch } from 'react-router-dom';
import { SecureRoute, useOktaAuth } from '@okta/okta-react';
// eslint-disable-next-line import/named
import { CustomUserClaim } from '@okta/okta-auth-js';
import { config } from '../../utils/config/config';
import { Week } from '../../components/week/week';
import { Spaces } from '../spaces/space';
import { AddSpace } from '../spaces/addSpace';
import { EditSpace } from '../spaces/editSpace';
import { Departments } from '../departments/department';
import { AddDepartment } from '../departments/addDepartment';
import { EditDepartment } from '../departments/editDepartment';

// Fonction pour transformer en tableau
function ensureArray(customClaim: CustomUserClaim | CustomUserClaim[]): CustomUserClaim[] {
  // Vérifie si 'customClaim' est déjà un tableau
  // eslint-disable-next-line unicorn/prefer-ternary
  if (Array.isArray(customClaim)) {
    return customClaim;
  } else {
    // Si ce n'est pas un tableau, on l'encapsule dans un tableau
    return [customClaim];
  }
}
/**
 * @function Routing It's the router of the application
 * @returns {JSX.Element} HTML content
 */
function Routing() {
  const [isSigned, setIsSigned] = useState<boolean>(true); // Supposons l'état initial non signé

  const getIsSigned = useDataApiIsSigned(isSigned); // Assurez-vous que le nom est correct

  if (isSigned !== getIsSigned) {
    setIsSigned(getIsSigned);
  }

  const { authState } = useOktaAuth();
  const groups = authState!.idToken!.claims.groups;

  if (!isSigned && isSigned !== undefined) {
    return (
    // Routes for users that didn't sign
      <Switch>
        <SecureRoute path="/charte" render={(properties) => <Charter {...properties} isSigned={isSigned} />} />
        <SecureRoute path="/profil" component={Profil} />
        <SecureRoute render={() => <Redirect to="/charte" />} />
      </Switch>
    );
  }
  return (
    // Every routes when a user signed
    <Switch>
      <SecureRoute exact path="/" component={Week} />
      <SecureRoute path="/charte" render={(properties) => <Charter {...properties} isSigned={isSigned} />} />
      <SecureRoute path="/profil" component={Profil} />
      <SecureRoute path="/informations" component={Information} />
      <SecureRoute path="/restaurants" render={(properties) => <ArticlesRender {...properties} isRestaurant={true} categoryId={undefined} />} />

      
      
      {ensureArray(groups).includes(`GG_APCOWORK_${config.ENV_GROUP}_EDITOR`) ?
        <>
          <SecureRoute path="/spaces" component={Spaces} />
          <SecureRoute path="/add-space" component={AddSpace} />
          <SecureRoute path="/edit-space/:id" component={EditSpace} />
              
          <SecureRoute path="/departments" component={Departments}  />
          <SecureRoute path="/add-department" component={AddDepartment} />
          <SecureRoute path="/edit-department/:id" component={EditDepartment} />
      
          <SecureRoute path="/articles" render={(properties) => <ArticlesRender {...properties} isRestaurant={false} categoryId={4} />} />
          <SecureRoute path="/add-article" component={AddArticle} />
          <SecureRoute path="/edit-article/:id" component={EditArticle} />
        </>
        :
        <>
          <Redirect to="/" />
        </>
      }
      <Redirect to="/" />
    </Switch>
  );
}


export { Routing }
